<template>
    <div class="card">
        <div class="row mt-2">
                <div class="col-lg-11 col-11 mx-auto">
                    <div class="card card-widget widget-user">
                    <div class="widget-user-header text-white"
                                    style="background: url('/assets/images/pexels-pixabay-Snow-Mountain2000fshead.png')  center;">
                                    <h3 class="widget-user-username text-left">We are the Result of our Action-Habits.</h3>
                                    <h2 class="widget-user-desc text-right">For Version 2.0 of You.</h2>
                                    <h3 class="widget-user-username text-right">The power of Consistent Action.</h3>
                                </div>
                                <div class="widget-user-image">
                                    <img class="img-circle" src="/assets/images/pexels-rodnae-productions-7005569_winner128x128.png" alt="User Avatar">
                                </div>
                    </div>
                </div>
        </div>

    <div class="card-body" style="background:#ddd;">
        <div class="col-12 text-center">
            <h2>Your Action-Habits Dashboard</h2>
        </div>
            <div class="row">
              <div class="col-sm-12 col-md-12 bordered">
                <div class="color-palette-set">
                    <div class="col-lg-6 col-6 mx-auto m-2">
                <div class="row mt-2 justify-content-between">
                        <button class="col btn-sm bg-warning" @click="displayModal">The Why &amp; How of Action-Habits &nbsp;<i class="fa fa-tv"></i></button>
                        <button class="col btn-sm bg-primary" @click="newActionHabitSetup">Setup an Action-Habit&nbsp;<i class="fas fa-plus"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>

       <div class="row">
              <div class="col-sm-12 col-md-12 bordered">
                <div class="color-palette-set">
                    <div class="col-lg-6 col-6 mx-auto m-2">
                        <div class="row mt-2 justify-content-center">
                        <div v-if="actionhabitData.length>0">
                            <select  v-model="currentactionhabitid" @change="setSelActionHabit()">
                                <option value="">Select an Action-Habit to track or review performance</option>
                                <option v-for="actionhabit in actionhabitData" :value="actionhabit.id" :key="actionhabit.id">{{actionhabit.name}}
                                    <!-- ({{habit.description}}) REMOVED TO FIT MOBILE-->
                                </option>
                            </select>
                            <!-- <button :disabled="currenthabitid ==''" class="btn btn-sm bg-light float-right" @click="displayTrackerModal()">Track My Performance &nbsp;<i class="fas fa-shoe-prints"></i></button>
                            <button :disabled="currenthabitid ==''" class="btn btn-sm bg-light float-right" @click="displayResultsModal()">Review My Performance &nbsp;<i class="fa fa-eye"></i></button>
                        -->
                        </div>
                          <div v-if="actionhabitData.length<1">
                           Please set up one or more Habits to track or view performance.
                        </div>
                     </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="currentactionhabitdata!=''" class="row mt-2 justify-content-center">
        <div class="content-box-gray card" >
            <div class="title text-center">
                <h5 class="mt-2" style="margin:auto;" >{{currentactionhabitdata.name}}</h5>
            </div>
            <div class="content justify-content-center">
                <button :disabled="currentactionhabitid ==''" class="btn btn-sm bg-light float-right" @click="displayActionTrackerModal()">Track My Performance &nbsp;<i class="fas fa-shoe-prints"></i></button>
                <button :disabled="currentactionhabitid ==''" class="btn btn-sm bg-light float-right" @click="displayResultsModal()">Review My Performance &nbsp;<i class="fa fa-eye"></i></button>

            </div>
        </div>
    </div>
</div>


</div>

       </div>
    </div>
</template>

<script>
import axios from 'axios';
import Errors from '../partials/Errors.vue';
import Swal from 'sweetalert2';
var _ = require('lodash');
import EventBus from '../../event-bus';
import { v4 as uuidv4 } from 'uuid';

export default {
    components: { Errors,
         },
    name: "ActionHabitDashboard",
    data() {
        return {
            userdata:[],
            currentactionhabitid:'',
            currentactionhabitdata:'',
            habit:'',
            errors: {
                nahme: '',
                message: '',
                    },
            actionhabittrackingdata:[],
            actionhabitData:[],
        }
    },
    props: {
        user:'',
        actionhabits:[],
        tracking:[],
    },
    mounted() {
        this.userdata = JSON.parse(this.user);
        this.actionhabitData= JSON.parse(this.actionhabits);
        this.actionhabittrackingdata = JSON.parse(this.tracking);
        this.currentactionhabitdata = '';
    },

    methods: {

    // trackActionHabit(action_habit_id) {
    //         console.error('track action_habit_id called.....');
    //         // window.location.href = "/habits/track/"+ habit_id;
    //         var selActionHabitData = this.getActionHabitData(action_habit_id);
    //         var data = {actionhabitdata: selActionHabitData, userdata:this.userdata }
    //         EventBus.$emit('displayActionHabitTrackerModal', data);
    //     },
   trackActionHabit(habit_id) {
            console.error('track habit called.....');
            var selHabitData = this.getActionHabitData(habit_id);
            var data = {habitdata: selHabitData, userdata:this.userdata }
            EventBus.$emit('displayActionHabitTrackerModal', data);
        },

        // getActionHabitData(action_habit_id) {
        //     var retVal = '';
        //     this.actionhabitData.forEach((aHabit)=>{
        //         if(aHabit.id == action_habit_id) retVal =aHabit;
        //     });
        //     return retVal;
        // },

  getActionHabitData(habit_id) {
            console.log("Looking for Habit with id: " + habit_id);
            var retVal = '';
            this.actionhabitData.forEach((aHabit)=>{
                console.log(aHabit.name + aHabit.id);
                if(aHabit.id == habit_id)  {
                    console.log("Found habit: " + aHabit.name);
                    retVal =  aHabit;
                }
            });
            return retVal;
        },

        displayResultsModal(){
            var selActionHabitData = this.getActionHabitData(this.currentactionhabitid);
            var selActionHabitTracking = this.getActionHabitTrackingData(this.currentactionhabitid);
            // console.error(this.actionhabittrackingdata);
            var data = {actionhabitdata: selActionHabitData,
                        userdata:  this.userdata,
                        actionhabittrakkerdata:  selActionHabitTracking,
                         };
            EventBus.$emit('displayActionHabitResultsModal', data);
        },
        getActionHabitTrackingData(habit_id) {
            var retVal = [];
             [...this.actionhabittrackingdata].forEach((aTrackingData)=>{
                if(aTrackingData.action_habit_id == habit_id) {
                    // console.log("Found: " + aTrackingData.attempt_count + ' ' + aTrackingData.streak + ' ' + aTrackingData.id);
                    retVal.push(aTrackingData);
                }
            });
            return retVal;
        },

        displayActionTrackerModal(){
            const payload = {habitdata:  this.currentactionhabitdata, userdata: this.userdata};
            EventBus.$emit('displayActionHabitTrackerModal', payload);
        },
        newActionHabitSetup(){
            window.location.replace('/actionhabits/setup');
        },
        showReview(){
            window.location.replace('/actionhabits/review/' + this.currenthabitid);
        },
        displayModal(){
            const payload ={title:  "Video Title goes here", videourl: ''};
            EventBus.$emit('displayVideoModal', payload);
        },

        setSelActionHabit() {
            var selActionHabit = '';
            selActionHabit = [...this.actionhabitData].filter((aHabit)=> {
                        if( aHabit.id == this.currentactionhabitid) return aHabit;
                });
            // console.log(selHabit);
            this.currentactionhabitdata = selActionHabit[0];
            // return selHabit[0];
        },
        track() {
             window.location.replace('/actionhabits/track/' + this.currentactionhabitid);
        }

        // informChart(newdata) {
        //      this.$root.$emit('updateChart', newdata);
        // },
        // selectHabit(id){
        //     console.error("Select habit: " + id);
        //     this.currenthabitdata = this.habitdata.filter((habit) => {
        //             console.log(habit.name + ", " + habit.id);
        //         return habit.id  == id;
        //     });
        //     this.currenthabitid = this.currenthabitdata[0].id;
        //     this.deletionsuccess = false;
        //     this.getHabitData(id);
        // },
        // disableClickedButton(compid) {
        //     document.getElementById(compid).disbled = true;
        // },
        // getHabitData(habitid) {
        //     if(habitid != '') {
        //         console.error("Tracking habit_component: " + habitid);
        //         axios.post('/habits/tracking/getbasedata', {
        //             user_id:this.userdata.id,
        //             habit_id: habitid,
        //         })
        //         .then(res => {
        //             this.loading = false;
        //             this.success = true;
        //             this.message = res.data.message;
        //             this.habittrackingdata = JSON.parse(res.data.tracking);
        //             this.componentdata = JSON.parse(res.data.components);
        //             this.failure = false;
        //         })
        //         .catch(err => {
        //             this.loading = false;
        //             this.failure = true;
        //             this.success = false;
        //             this.message =err.message;
        //         })
        //         .finally(() => {
        //                 //  console.error('In delete finally.....');
        //                 // console.error(incomingdata);
        //                 this.$forceUpdate();
        //         });
        //     }

        // },

        // trackDone(compid, compweight) {
        //     let incomingdata = '';
        //     console.error("Tracking habit_component: " + compid);
        //     axios.post('/habits/tracking/update', {
        //         user_id:this.userdata.id,
        //         component_id: compid,
        //         points: compweight,
        //         habit_id: this.habit_id,
        //     })
        //     .then(res => {
        //         this.loading = false;
        //         this.success = true;
        //         this.message = res.data.message;
        //         this.failure = false;
        //     })
        //     .catch(err => {
        //         this.loading = false;
        //         this.failure = true;
        //         this.success = false;
        //     })
        //     .finally(() => {
        //             //  console.error('In delete finally.....');
        //             // console.error(incomingdata);
        //             this.disableClickedButton(compid);
        //             this.informChart();
        //             this.$forceUpdate();
        //         });

        // },

        // startTracking(habit_id) {
        // },

        // drop(habit_id) {
        //     let incomingdata = '';
        //     console.error("Deleting habit: " + habit_id);
        //     axios.post('/habits/delete', {
        //         user_id:this.userdata.id,
        //         habit_id: habit_id
        //     })
        //     .then(res => {
        //         this.loading = false;
        //         this.success = true;
        //         this.message = res.data.message;
        //         this.errors.success = true;
        //         this.deletionsuccess = true;
        //         this.errors.nahme = res.data.message;
        //         // console.errors(res.data.habits);
        //         // this.habitdata= JSON.parse( res.data.habits);
        //         incomingdata = res.data.habits;
        //         this.currenthabitid = '';
        //         this.currenthabitdata = [];
        //         console.error("Got " + this.habitdata.length + " habits after deletion");
        //         this.removeHabitFromHabitData(habit_id);
        //         this.failure = false;
        //     })
        //     .catch(err => {
        //         this.loading = false;
        //         this.failure = true;
        //         this.success = false;
        //     })
        //     .finally(() => {
        //             //  console.error('In delete finally.....');
        //             // console.error(incomingdata);
        //             this.habitdata = JSON.parse(incomingdata);
        //             this.$forceUpdate();
        //         });
        // },
        // removeHabitFromHabitData(habit_id) {
        //      this.habitdata = this.habitdata.filter(function (habit){
        //     return habit.id !== habit_id});
        // },
        // saveHeaders(habit_name, habit_frequency, habit_description) {
        //     axios.post('/habits/headers/saveupdate', {
        //         user_id:this.userdata.id,
        //         // habit_id: habit_id,
        //         name: habit_name,
        //         freq: habit_frequency,
        //         description: habit_description
        //     })
        //     .then(res => {
        //         this.loading = false;
        //         this.success = true;
        //         this.message = res.data.message;
        //         this.saved_habit_id = res.data.habit_id;
        //         console.error(res.data.message + this.saved_habit_id);
        //         this.failure = false;

        //         // setTimeout(() => {
        //         //     window.location.href = '/home'
        //         // }, 1000)
        //     })
        //     .catch(err => {
        //         this.loading = false;
        //         this.failure = true;
        //         // // Show the error message
        //         // this.message = err.response.data.message;
        //         // this.errors.name = err.response.data.errors.name ? err.response.data.errors.name[0] : null;
        //         // this.errors.email = err.response.data.errors.email ? err.response.data.errors.email[0] : null;
        //         // this.errors.username = err.response.data.errors.username ? err.response.data.errors.username[0] : null;
        //         // this.errors.password = err.response.data.errors.password ? err.response.data.errors.password[0] : null;
        //         this.success = false;
        //     })
        // },

    }


}
</script>

<style scoped>
.habit-page {
  -ms-flex-align: center;
  align-items: center;
  background: #e9ecef;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100vh;
  -ms-flex-pack: center;
  justify-content: center;
}
.habit-box {
  width: 540px;

}

.habit-card-body {
  background: #eee;
  border-top: 0;
  color: #666;
  padding: 20px;
}
.habit-card-sub-body {
    width:80%;
    border:3px solid #fff;
    background: rgb(209, 219, 248);
    border-top: 1em;
    margin: 4.4em;
    color: #666;
    padding: 20px;
    border-radius:4px;/*2em 2em 0em 0em;*/
    box-shadow: #ddd 4px 4px 4px;
}
.input-group{
margin-bottom:.4em;
}

.btn-container{
display:flex;
margin:1em;
}
a, button {
margin-left:auto;
}
.div-box{
margin: 2em;
padding: 2em;
border: solid 1px #fff;
box-shadow: 4px 4px 4px #666;
 border-radius:2em 2em 0em 0em;
}
.customElements{
margin: 2em;
padding: 2em;
border: solid  1px #fff;
border-radius:2em 2em 0em 0em;
box-shadow: 4px 4px 4px #666;
}
.header-box-msg, .habit-table-head{
padding:.75em;
background:#343a40;
color:#ffc107;
}
.tracker-btn{
    margin-top: .5em;
    margin-bottom: .5em;
    margin-left:1em;
    /* margin-right:1em; */
    width:80%;
    padding: .5em;
    /* align-content: center; */
}
.fai-red{
    color:rgb(129, 67, 67);
}
.fai-green{
    color:rgb(65, 131, 65);
}




.mobile-first,
.desktop-first {
  padding: 1em;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.15);
  margin: 2em auto;
  max-width: 750px;
}

/*  mobile-first */
@media (min-width: 600px) {
  .mobile-first .sales-points {
    display: flex;
    justify-content: space-between;
  }

  .mobile-first .sales-point {
    width: 30%;
  }
}

/* desktop first */
.desktop-first .sales-points {
  display: flex;
  justify-content: space-between;
}

.desktop-first .sales-point {
  width: 30%;
}

@media (max-width: 600px) {
  .desktop-first .sales-points {
    display: block;
  }

  .desktop-first .sales-point {
    width: 100%;
  }
}

.content-box-gray .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
    background:#876759;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}







</style>
